module.exports = __webpack_public_path__ + "static/img/apm.56a701f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apm.png
// module id = eTyI
// module chunks = 1